import { create } from 'zustand';
import { TOTAL_STEPS } from '../components/Tutorial/tutorialSteps';

const STORAGE_KEY = 'stride-tutorial-completed';

interface TutorialState {
  currentStep: number;
  isActive: boolean;
  isCompleted: boolean;
  startTutorial: () => void;
  nextStep: () => void;
  prevStep: () => void;
  skipTutorial: () => void;
  completeTutorial: () => void;
  replayTutorial: () => void;
  advanceIfStep: (step: number) => void;
}

const isCompleted = localStorage.getItem(STORAGE_KEY) === 'true';

export const useTutorialStore = create<TutorialState>((set, get) => ({
  currentStep: 0,
  isActive: false,
  isCompleted,
  startTutorial: () => set({ isActive: true, currentStep: 0 }),
  nextStep: () => {
    const { currentStep } = get();
    const next = currentStep + 1;
    if (next >= TOTAL_STEPS) {
      get().completeTutorial();
    } else {
      set({ currentStep: next });
    }
  },
  prevStep: () => {
    const { currentStep } = get();
    set({ currentStep: Math.max(0, currentStep - 1) });
  },
  skipTutorial: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ isActive: false, isCompleted: true });
  },
  completeTutorial: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ isActive: false, isCompleted: true });
  },
  replayTutorial: () => set({ currentStep: 0, isActive: true }),
  advanceIfStep: (step: number) => {
    const { currentStep, isActive } = get();
    if (isActive && currentStep === step) {
      get().nextStep();
    }
  },
}));
